import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '../role.guard';
import { AddCustomerComponent } from './add-customer/add-customer.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { CustomersComponent } from './customers/customers.component';
import { MandoobsBallanceComponent } from './mandoobs-ballance/mandoobs-ballance.component';
import { AddmandoobComponent } from './mandoobs/addmandoob/addmandoob.component';
import { MandoobslistComponent } from './mandoobs/mandoobslist/mandoobslist.component';
import { MessagesComponent } from './messages/messages.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { InfoformComponent } from './otherinfo/infoform/infoform.component';
import { ListInfoComponent } from './otherinfo/list-info/list-info.component';
import { PermNotificationsComponent } from './perm-notifications/perm-notifications.component';
import { ProfileComponent } from './profile/profile.component';
import { SendSMSComponent } from './send-sms/send-sms.component';
import { SystemDataComponent } from './system-data/system-data.component';
import { UserbalanceComponent } from './userbalance/userbalance.component';
import { AdduserComponent } from './users/adduser/adduser.component';
import { DirectChargeOrdersComponent } from './direct-charge-orders/direct-charge-orders.component';

const routes: Routes = [
  { path: "adduser", component: AdduserComponent },
  { path: "addMandoob", component: AddmandoobComponent },
  { path: "editMandoob/:id", component: AddmandoobComponent },
  { path: "mandoobsList", component: MandoobslistComponent },
  { path: "updateuserbalance", component: UserbalanceComponent },
  { path: "updatemandoobbalance", component: MandoobsBallanceComponent },
  { path: "messages", component: MessagesComponent },
  { path: "profile", component: ProfileComponent },
  { path: "changePassword", component: ChangepasswordComponent },
  { path: "systemdata", component: SystemDataComponent },
  { path: "customers", component: CustomersComponent },
  { path: "notification", component: NotificationsComponent },
  { path: "addcustomer", component: AddCustomerComponent },
  { path: "alert", component: PermNotificationsComponent },
  { path: "sendSMS", component: SendSMSComponent },
  { path: "otherInfoList", component: ListInfoComponent },
  { path: "addinfo", component: InfoformComponent },
  { path: "editinfo/:id", component: InfoformComponent },
  { path: "directcharge", component: DirectChargeOrdersComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OptionsRoutingModule { }
